// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__JrTWb","productName":"Table_productName__2UKAh"};